var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-wrapper"},[_c('div',{staticClass:"share-info"},[_vm._v("选择分享地址")]),_c('span',{staticClass:"share-items"})])
}]

export { render, staticRenderFns }